'use client';

import { useState } from 'react';

import { Button, Image } from '@bytel/trilogy-react-ts';

function showIcon({
    isSelected,
    isHovered,
    is5g,
    isRoaming,
    isPrime,
    isServiceMax,
}: {
    isSelected?: boolean;
    isHovered?: boolean;
    isRoaming?: boolean;
    is5g?: boolean;
    isPrime?: boolean;
    isServiceMax?: boolean;
}) {
    const selectedClass = isSelected ? 'is-white' : '';
    if (isPrime) {
        return (
            <span className={`icon is-small me-0 isSuper ${selectedClass}`}>
                <i
                    aria-label='amazon prime'
                    className='tri-primeIcon'
                    style={{
                        WebkitMask:
                            'url(https://www.bouyguestelecom.fr/assets/media/original/image/CMS/ecommerce/byou/prime_Logo.svg) no-repeat center',
                        WebkitMaskSize: 'contain',
                        mask: 'url(https://www.bouyguestelecom.fr/assets/media/original/image/CMS/ecommerce/byou/prime_Logo.svg) no-repeat center',
                        maskSize: '20px',
                    }}
                />
                <span className='is-hidden'>amazon prime</span>
            </span>
        );
    }
    if (isServiceMax) {
        return (
            <span className={`icon me-0 isSuper ${selectedClass}`}>
                <Image
                    src={`https://www.bouyguestelecom.fr/assets/media/original/image/CMS/ecommerce/byou/serviceMax${isSelected || isHovered ? '-w' : ''}.svg`}
                    alt='service max'
                    width={63}
                    height={20}
                />
                <span className='is-hidden'>Service Max</span>
            </span>
        );
    }
    if (is5g) {
        return (
            <span className={`icon is-small me-0 isSuper ${selectedClass}`}>
                <i className='tri-5g' aria-hidden='true' aria-label='5G'>
                    <span className='is-hidden'>5G</span>
                </i>
            </span>
        );
    }
    if (isRoaming) {
        return (
            <span className={`icon is-small me-0 icoR isSuper ${selectedClass}`}>
                <i className='tri-air-travel mb-4' aria-hidden='true' aria-label='Itinérance'>
                    <span className='is-hidden'>Itinérance</span>
                </i>
            </span>
        );
    }
}

interface DataButtonProps {
    data: string;
    isSelected?: boolean;
    is5g?: boolean;
    isPrime?: boolean;
    isRoaming?: boolean;
    isServiceMax?: boolean;
    onPress: () => void;
}

export function DataButton({
    data,
    isSelected,
    is5g,
    isRoaming,
    isPrime,
    onPress,
    isServiceMax,
}: Readonly<DataButtonProps>) {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <li className='bwaConfLi' onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
            <Button
                className={`bwaConf ${isSelected ? 'is-active' : 'has-background-grey-lighter'}`}
                onClick={() => onPress()}
                accessibilityLabel={`Forfait ${data}`}
            >
                {data}
                {showIcon({
                    isSelected,
                    isHovered,
                    is5g,
                    isRoaming,
                    isServiceMax,
                    isPrime,
                })}
            </Button>
        </li>
    );
}
